import clsx from 'clsx'
import SAISVG, { toAbsoluteUrl } from "../../../helpers/CommonFunction";
import HeaderUserMenu from '../../../partials/layout/header-menus/HeaderUserMenu';
import { useLayout } from '../../core/LayoutProvider';
import { Link, useParams } from 'react-router-dom';

const itemClass = 'ms-1 ms-lg-3'
const userAvatarClass = 'symbol-35px symbol-md-40px'
const btnIconClass = 'svg-icon-1'

const DevNavbar = () => {
    const { config } = useLayout()
    const { company } = useParams();
    return (
        <div className='app-navbar flex-shrink-0'>
            {/* <div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
                <Search />
            </div> */}

            {/* <div className={clsx('app-navbar-item', itemClass)}>
                <div id='sai_activities_toggle'>
                <SAISVG path='media/icons/duotune/general/gen032.svg' className={btnIconClass} />
                </div>
            </div> */}

            {/* <div className={clsx('app-navbar-item', itemClass)}>
                <div
                    data-sai-menu-trigger="{default: 'click'}"
                    data-sai-menu-attach='parent'
                    data-sai-menu-placement='bottom-end'
                    className={btnClass}
                >
                    <SAISVG path='media/icons/duotune/general/gen022.svg' className={btnIconClass} />
                </div>
                <HeaderNotificationsMenu />
            </div> */}

            {/* <div className={clsx('app-navbar-item', itemClass)}>
                <div className={clsx('position-relative', btnClass)} id='sai_drawer_chat_toggle'>
                <SAISVG path='media/icons/duotune/communication/com012.svg' className={btnIconClass} />
                <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
                </div>
            </div> */}

            <div className={clsx('app-navbar-item', itemClass)}>
                <div
                    className={clsx('cursor-pointer symbol', userAvatarClass)}
                    data-sai-menu-trigger="{default: 'click'}"
                    data-sai-menu-attach='parent'
                    data-sai-menu-placement='bottom-end'
                >
                    <img src={toAbsoluteUrl('media/avatars/300-1.jpg')} alt='' />
                </div>
                <HeaderUserMenu />
            </div>

            {config.app?.header?.default?.menu?.display && (
                <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
                    <div
                        className='btn btn-icon btn-active-color-primary w-35px h-35px'
                        id='sai_app_header_menu_toggle'
                    >
                        <SAISVG path='media/icons/duotune/text/txt001.svg' className={btnIconClass} />
                    </div>
                </div>
            )}
        </div>
    )
}

export default DevNavbar;